import type { AdDesignData } from '@jobilla/nexus-sdk'
import { useContext } from 'react'
import { designGalleryModeAtom, designGalleryOpenAtom, designGalleryPromiseAtom } from './atoms'
import { DesignGalleryStoreContext } from './store'
import type { DesignGalleryMode } from './types'

export function useDesignGallery() {
	const store = useContext(DesignGalleryStoreContext)
	if (!store) {
		throw new Error('useDesignGallery must be used within a DesignGalleryManager')
	}

	const open = (mode: DesignGalleryMode = 'picker'): Promise<AdDesignData | undefined> => {
		return new Promise<AdDesignData | undefined>((resolve, reject) => {
			// If a previous promise is pending, reject it
			const prev = store.get(designGalleryPromiseAtom)
			if (prev) {
				prev.reject(new DOMException('Design gallery was re-opened by another caller', 'AbortError'))
			}

			store.set(designGalleryModeAtom, mode)
			store.set(designGalleryPromiseAtom, { resolve, reject })
			store.set(designGalleryOpenAtom, true)
		})
	}

	const close = () => {
		const current = store.get(designGalleryPromiseAtom)
		if (current) {
			current.resolve(undefined)
		}
		store.set(designGalleryPromiseAtom, null)
		store.set(designGalleryOpenAtom, false)
	}

	return { open, close }
}
